<template>
  <div class="page-footer">
    <div class="footer-content">
      <img
          src="@/assets/index-bottom.png"
          alt="footer-left"
          class="footer-image"
      />
      <img

          src="@/assets/index-bottom.png"
          alt="footer-right"
          class="footer-image footer-image-right"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageFooter',
}
</script>

<style lang="scss" scoped>
.page-footer {
  width: 100%;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  margin-top: 10px;

  .footer-content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 200px;
    // transform: rotate(0deg) scaleX(-1) scaleY(1) rotateZ(360deg);
    .footer-image {
      height: 46px;
      width: auto;
      object-fit: contain;
    }
    .footer-image-right {
      transform: scaleX(-1);
    }
  }
}
</style>

